import React from "react";
import { Button } from "./ui/button";
import { ArrowRight, Play, Award, Users, Building, Phone } from "lucide-react";

const Hero = () => {
  const scrollToId = (id) => {
    const el = document.getElementById(id);
    if (!el) {
      console.warn(`ID não encontrado: #${id}`);
      return;
    }
    el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  const openWhatsApp = () => {
    window.open("https://wa.me/5561981255035", "_blank", "noopener,noreferrer");
  };

  return (
    <section
      id="home"
      className="relative min-h-screen flex items-center justify-center overflow-hidden bg-gradient-to-br from-gray-50 to-white"
    >
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5 pointer-events-none" aria-hidden="true">
        <div
          className="absolute inset-0"
          style={{
            backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23FF1616' fill-opacity='0.1'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
          }}
        />
      </div>

      <div className="container mx-auto px-4 py-20 relative z-10">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div className="text-center lg:text-left space-y-8">
            <div className="space-y-6">
              <div className="inline-flex items-center px-4 py-2 bg-red-50 text-[#FF1616] rounded-full text-sm font-bold tracking-wide">
                <Award className="w-4 h-4 mr-2" />
                10+ ANOS CRIANDO EXPERIÊNCIAS
              </div>

              <h1 className="text-4xl md:text-6xl lg:text-7xl font-black text-gray-900 leading-tight tracking-tight">
                STANDS &{" "}
                <span className="text-[#FF1616] block">ESTRUTURAS</span>{" "}
                QUE IMPRESSIONAM
              </h1>

              <p className="text-xl text-gray-600 leading-relaxed max-w-2xl font-medium">
                Montagem de stands, quiosques, ambientações e cenografias.
                <strong> Do projeto à execução</strong>, criamos experiências que
                conectam sua marca ao público-alvo.
              </p>
            </div>


<div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start">
  <Button
    size="lg"
    className="bg-[#FF1616] hover:bg-red-700 text-white px-8 py-4 text-lg font-bold tracking-wide group"
    onClick={() => scrollToId("portfolio")}
    type="button"
  >
    VER PORTFÓLIO
    <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" />
  </Button>

  <Button
    size="lg"
    variant="outline"
    className="border-2 border-gray-300 text-gray-700 hover:border-[#FF1616] hover:text-[#FF1616] px-8 py-4 text-lg group font-bold tracking-wide"
    onClick={() => scrollToId("processo")}
    type="button"
  >
    <Play className="mr-2 w-5 h-5" />
    NOSSO PROCESSO
  </Button>
</div>

            {/* Contact CTA */}
            <div className="bg-gradient-to-r from-[#FF1616] to-red-700 rounded-2xl p-6 text-white">
              <div className="flex items-center justify-between gap-4 flex-col sm:flex-row">
                <div className="text-center sm:text-left">
                  <div className="text-lg font-bold mb-1">
                    Pronto para começar?
                  </div>
                  <div className="text-red-100">Fale com nossa equipe agora</div>
                </div>

              <Button
      variant="outline"
      size="lg"
      className="bg-white text-[#FF1616] border-white hover:bg-red-50 font-bold tracking-wide w-full sm:w-auto"
      onClick={openWhatsApp}
      type="button"
    >
      <Phone className="mr-2 w-4 h-4" />
      (61) 98125-5035
    </Button>
  </div>
</div>

      {/* Stats */}
<div className="grid grid-cols-3 gap-8 pt-8 border-t border-gray-200">
              <div className="text-center lg:text-left">
                <div className="text-3xl font-black text-gray-900">400+</div>
                <div className="text-gray-600 text-sm font-medium tracking-wide">
                  PROJETOS ENTREGUES
                </div>
              </div>
              <div className="text-center lg:text-left">
                <div className="text-3xl font-black text-gray-900">10+</div>
                <div className="text-gray-600 text-sm font-medium tracking-wide">
                  ANOS DE MERCADO
                </div>
              </div>
              <div className="text-center lg:text-left">
                <div className="text-3xl font-black text-gray-900">98%</div>
                <div className="text-gray-600 text-sm font-medium tracking-wide">
                  SATISFAÇÃO DO CLIENTE
                </div>
              </div>
            </div>
          </div>

          {/* Right Content - Visual */}
          <div className="relative">
            {/* Main Image */}
            <div className="relative z-10">
              <img
                src="https://images.unsplash.com/photo-1632383380175-812d44ec112b"
                alt="Stand Forttana Eventos"
                className="rounded-2xl shadow-2xl w-full h-[500px] object-cover"
              />

              {/* Floating Cards */}
              <div className="absolute -top-6 -left-6 bg-white rounded-xl shadow-lg p-4 border border-gray-100">
                <div className="flex items-center space-x-3">
                  <div className="w-10 h-10 bg-[#FF1616] rounded-lg flex items-center justify-center">
                    <Building className="w-5 h-5 text-white" />
                  </div>
                  <div>
                    <div className="font-bold text-gray-900 tracking-wide">
                      PROJETO 3D
                    </div>
                    <div className="text-sm text-gray-600">
                      Visualização Realística
                    </div>
                  </div>
                </div>
              </div>

              <div className="absolute -bottom-6 -right-6 bg-white rounded-xl shadow-lg p-4 border border-gray-100">
                <div className="flex items-center space-x-3">
                  <div className="w-10 h-10 bg-gradient-to-r from-gray-600 to-gray-800 rounded-lg flex items-center justify-center">
                    <Users className="w-5 h-5 text-white" />
                  </div>
                  <div>
                    <div className="font-bold text-gray-900 tracking-wide">
                      EQUIPE EXPERT
                    </div>
                    <div className="text-sm text-gray-600">
                      Profissionais Qualificados
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Background Decoration */}
            <div className="absolute top-8 right-8 w-72 h-72 bg-gradient-to-br from-red-100 to-red-200 rounded-full blur-3xl -z-10 opacity-50"></div>
            <div className="absolute bottom-8 left-8 w-60 h-60 bg-gradient-to-br from-gray-100 to-gray-200 rounded-full blur-3xl -z-10 opacity-50"></div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
